import axios from "axios";
import UserService from "rc-app/services/UserService";

export const getMetaModels = async (projectId, page = 0, limit = 20) => {
  try {
    const API_URL = `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/views/meta_models?project_id=${projectId}&page=${page}&limit=${limit}`;

    const response = await axios.get(API_URL, {
      headers: {
        Authorization: `Bearer ${UserService.getToken()}`,
        "ngrok-skip-browser-warning": "disabled",
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching meta models:", error);
    throw error;
  }
};

export const updateMetaModel = async (metaModelId, jsonData) => {
  try {
    console.log("update Meta Model", metaModelId, jsonData);

    const API_URL = `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/actions/meta_models/${metaModelId}`;
    const PAYLOAD = {
      ...jsonData,
    };

    const response = await axios.put(API_URL, PAYLOAD, {
      headers: {
        Authorization: `Bearer ${UserService.getToken()}`,
        "ngrok-skip-browser-warning": "disabled",
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error updating meta model:", error);
    throw error;
  }
};

export const deleteMetaModel = async (metaModelId) => {
  try {
    const API_URL = `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/actions/meta_models/${metaModelId}`;

    const response = await axios.put(API_URL, { is_active: false }, {
      headers: {
        Authorization: `Bearer ${UserService.getToken()}`,
        "ngrok-skip-browser-warning": "disabled",
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error deleting meta model:", error);
    throw error;
  }
};

export const createMetaModel = async (jsonData) => {
  try {
    console.log("create Meta Model", jsonData);

    const API_URL = `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/actions/meta_models`;
    const PAYLOAD = {
      ...jsonData,
    };

    const response = await axios.post(API_URL, PAYLOAD, {
      headers: {
        Authorization: `Bearer ${UserService.getToken()}`,
        "ngrok-skip-browser-warning": "disabled",
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error creating meta model:", error);
    throw error;
  }
};
